import { render, staticRenderFns } from "./calendarItemStyle.vue?vue&type=template&id=f2983b2e&scoped=true"
import script from "./calendarItemStyle.vue?vue&type=script&lang=js"
export * from "./calendarItemStyle.vue?vue&type=script&lang=js"
import style0 from "./calendarItemStyle.vue?vue&type=style&index=0&id=f2983b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2983b2e",
  null
  
)

export default component.exports